import { Outlet, useParams } from 'react-router-dom'

import useGetObject from '@app/hooks/useGetObject'
import Header from '@app/pages/metrics/components/header'
import { PageStack } from '@app/shared/layout'
import withAwait from '@app/shared/withAwait'

const Show = () => {
  const { nodeId, strategyId } = useParams()

  const metric = useGetObject(nodeId, 'metric')

  if (!metric) {
    return null
  }

  return (
    <PageStack bg="bg">
      <Header metric={metric} strategyId={strategyId} />
      <Outlet />
    </PageStack>
  )
}

export default withAwait(Show, 'metric')
